import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { ToastsProvider } from "./contexts/toasts";
import { AuthProvider } from "./contexts/auth";
import AppRouter from "./router/AppRouter";

function App() {
  return <AppRouter />;
}

export default function withContext() {
  return (
    <HelmetProvider>
      <ToastsProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastsProvider>
    </HelmetProvider>
  );
}
